import { Pagination, PaginationParams } from "@/modules/common/types/Pagination";
import api from "../api";
import { EnergyDistributorResponse } from "../response/energy-distributors";

export const ENERGY_DISTRIBUTORS_ENDPOINTS = {
  LIST: "/v1/energy-distributors",
};

export const EnergyDistributorsService = {
  list: async (params: PaginationParams): Promise<Pagination<EnergyDistributorResponse>> => {
    const response = await api.get(ENERGY_DISTRIBUTORS_ENDPOINTS.LIST, { params });
    return response.data;
  },
};
